import { render, staticRenderFns } from "./error500.vue?vue&type=template&id=07ded77b&"
import script from "./error500.vue?vue&type=script&lang=js&"
export * from "./error500.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports